"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _PropTypes = require("./PropTypes.js");

var _Fieldset = _interopRequireDefault(require("./common/Fieldset.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Unit = function Unit(_ref) {
  var unit = _ref.unit,
      available = _ref.available,
      onChangeUnit = _ref.onChangeUnit;
  return available.length === 1 ? /*#__PURE__*/_react["default"].createElement("div", null, available[0]) : /*#__PURE__*/_react["default"].createElement(_Fieldset["default"], {
    value: unit,
    onChangeValue: onChangeUnit,
    options: available.map(function (n) {
      return [n, n];
    })
  });
};

Unit.propTypes = {
  unit: _PropTypes.UnitType.isRequired,
  available: _propTypes["default"].arrayOf(_PropTypes.UnitType.isRequired).isRequired,
  onChangeUnit: _propTypes["default"].func.isRequired
};
var _default = Unit;
exports["default"] = _default;